import { render, staticRenderFns } from "./index.vue?vue&type=template&id=071df97f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=071df97f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzDateCalendarInput: require('/opt/airport.kg/node_modules/razlet-ui/src/components/date-calendar-input/index.vue').default,RzSelect: require('/opt/airport.kg/node_modules/razlet-ui/src/components/select/index.vue').default,BaseSearchWithButton: require('/opt/airport.kg/src/components/base/search-with-button.vue').default})
